import { render } from "./CheckInput.vue?vue&type=template&id=0b532ad9"
import script from "./CheckInput.vue?vue&type=script&lang=js"
export * from "./CheckInput.vue?vue&type=script&lang=js"

import "./CheckInput.vue?vue&type=style&index=0&id=0b532ad9&lang=css"
script.render = render

export default script